import { render } from "./statsCards.vue?vue&type=template&id=98a55f1a&scoped=true"
import script from "./statsCards.vue?vue&type=script&lang=js"
export * from "./statsCards.vue?vue&type=script&lang=js"

import "./statsCards.vue?vue&type=style&index=0&id=98a55f1a&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a55f1a"]])

export default __exports__